<template>
  <modal name="faqModal" class="event-modal faq-modal" :width="'90%'" :height="'auto'" :scrollable="true">
    <div class="modal-header">
      <div class="modal-header-text">
        <span>BIOMETRIC EVENT INFORMATION AND POLICIES</span>
      </div>
      <!--<div class="modal-close-button" @click="hideModal()">X</div>-->
      <div class="modal-close-img" @click="hideModal()" @mouseover="isHoverClose = true"
           @mouseleave="isHoverClose = false">
        <img src="../../../static/img/info-modal-close.svg" alt="close" v-if="!isHoverClose">
        <img src="../../../static/img/info-modal-close-hover.svg" alt="close" v-if="isHoverClose">
      </div>
      <!-- <div class="line"></div> -->
    </div>
    <div class="modal-body">
      <div class="faq-section">
        <span class="modal-body-title">Standard Biometric Event</span><br/>
        <span class="modal-body-text">A standard biometric event includes: Finger Stick Blood Draw testing for Total Cholesterol, LDL, HDL, Trig and Blood Glucose. Wellmetrics testing for Blood Pressure, Heart Rate, Body Mass Index (BMI), Waist to Height Ratio (WtHR). If you require services outside of these standard options, please indicate in the custom event notes. </span>
      </div>
      <div class="faq-section">
        <span class="modal-body-title">Definition of an "Event":</span><br/>
        <span class="modal-body-text">• Each event subject to Event minimum billing stipulations</span><br/>

        <span class="modal-body-text">• Multiple shifts at one location on any single day that are separated by 2 or more hours are considered separate Events</span><br/>
        <span
          class="modal-body-text">• Events on multiple days in one location are considered a separate Event</span><br/>
        <span class="modal-body-text">• Each location at same day events is considered a separate Event</span><br/>
        <span class="modal-body-text">• Events are a minimum of 4 hours in one day.  Additional fees may be incurred if events are less than 4 hours in duration, or greater then 8 hours.</span>
      </div>
      <div class="faq-section">
        <span class="modal-body-title">Policy Information</span><br/>
        <span class="modal-body-sub-title">Cancelling or Rescheduling an Event</span><br/>
        <span class="modal-body-text">Events cancelled or rescheduled 31 days or more prior to an event will not incur any administrative fees.</span><br/>
        <span class="modal-body-text">Events cancelled or rescheduled 14 to 30 days prior to an event will be charged and billed for 50% the rate of the event, as well as any direct, non-refundable travel expenses already purchased.  Events cancelled less than 14 days prior to event date will be charged and billed for 100% the rate of the event, as well as any direct, non-refundable travel expenses already purchased.</span><br/><br/>
        <span class="modal-body-sub-title">ADURO Event Weather Policy</span><br/>
        <span class="modal-body-text">In the case of inclement weather, it is the responsibility of the client to cancel the event. ADURO will make every reasonable effort to continue on with an event until notified by the client. If an Event is cancelled by the client due to inclement weather, the client is responsible for all non-refundable costs (such as Lead travel). ADURO reserves the right to cancel an event due to safety concerns related to the weather at any time. ADURO will make every reasonable effort to rescheduled a cancelled event within 30 days of original date.  The Client will not incur any cancellation or rescheduling fees due to weather.</span><br/><br/>
        <span class="modal-body-sub-title">Service Changes to an Event</span><br/>
        <span class="modal-body-text">Allowable service changes made within 30 days of the scheduled event are not guaranteed and will incur a $250 service fee per change if accepted.  Allowable service changes include a change in the times of the event, an increase in the number of projected participation, or a change of location within the same metro area.  Changes made outside of 30 days do not incur a fee.  Changes will not be accepted within 15 days of the event. To request service changes to an event, please complete the Change Order Form and submit it to the Event Manager.</span><br/><br/>
        <span class="modal-body-sub-title">Events in Remote Locations</span><br/>
        <span class="modal-body-text">Locations more than 60 miles from an international airport will incur additional fees including travel expenses for all staff members (rental car, hotel and per diem).  An ADURO Event Manager will notify client if and when additional expenses will be charged when draft of SOF is received.</span><br/>
        <span class="modal-body-text">Events requiring more than 7 screening stations: Any event that requires more than 7 screening stations will require 2 Event Leads. Screening stations are determined based on event duration and projected participation.</span><br/><br/>
        <span class="modal-body-sub-title">Deposit and Final Billing</span><br/>
        <span class="modal-body-text">A deposit will be billed out at 50% of the projected participation to confirm each Event.  Deposit payment due upon receipt of deposit invoice. Final billing per event will be whichever is the greater:  1) Actual participation  OR  2) $2,500 site minimum  OR  3) 80% of the expected participation (may not apply to all, see contract for specific details). Biometrics final invoices will include actual travel expenses for the Event Lead(s) (air fare, hotel, auto, per diem).</span>
      </div>
    </div>
  </modal>
</template>
<script>
  export default {
    name: '',
    components: {},
    data () {
      return {
        isHoverClose: false
      }
    },
    methods: {
      hideModal () {
        this.$modal.hide('faqModal');
      }
    },
    computed: {}
  }
</script>

<style lang="less" scoped="">
  @import '../../styles/variables.less';

  .faq-modal {
    padding-top: 25px;
    padding-bottom: 25px;
  }

  .event-modal {
    margin: 0;
    background: rgba(0, 0, 0, 0.4);

    .modal-close-button {
      float: right;
      font-size: 20px;
      &:hover {
        cursor: pointer;
      }
    }

    .modal-header {
      border: 0;
      width: 100%;
      padding: 0 65px;
      margin: 0 auto;

      .line {
        box-sizing: border-box;
        height: 3px;
        width: 593px;
        border: 1px solid #E6E6E6;
      }
      .modal-header-text {
        margin-top: 50px;
        height: 40px;
        color: #231f20;
        font-family: Arquitecta, sans-serif;
        font-size: 24px;
        font-weight: bold;
        line-height: 30px;
        text-transform: uppercase;
        border-bottom: 1px solid #c2cfd6;
        width: 80%;
      }
      .modal-header-change-order-text {
        margin-top: 25px;
        margin-left: 25px;
        height: 29px;
        width: auto;
        color: @black;
        font-family: @font-family-title;
        font-size: 24px;
        font-weight: bold;
        line-height: 29px;
        text-transform: uppercase;
      }
      .modal-header-line {
        box-sizing: border-box;
        height: 3px;
        width: 593px;
        border: 1px solid @grey-4;
      }
      .modal-close-img {
        position: absolute;
        right: 17px;
        top: 17px;
        &:hover {
          cursor: pointer;
        }
      }
    }
    .modal-body {
      height: auto;
      width: 100%;
      margin: 0 auto;
      padding: 0 65px 25px 65px;
      .faq-section {
        padding: 20px 0;
        border-bottom: solid 1px @grey-4;
        &:last-child {
          border-bottom: none;
        }
        .modal-body-title {
          font-family: @font-family-main;
          font-size: 18px;
          font-weight: bold;
          line-height: 50px;
        }
        .modal-body-sub-title {
          font-weight: 600;
        }
        .modal-body-text {
          color: @black;
          font-family: @font-family-main;
          font-size: 14px;
          line-height: 18px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// FaqModal.vue?87adae82